import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TitleBar from "../Layout/titleBar";
import MyDialog from "../Layout/myDialog";
import { Row, Col } from "react-flexbox-grid";
import Item from "./itemNivel";
import { sagaGetNiveles } from "../../reducers/nivelesReducer/actions";
import "./niveles.css";
import Pagination from "../Layout/pagination";

const NivelesListado = (props) => {
  const { niveles, mapToItem } = props;

  const [itemsNiveles, setItemsNiveles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;

  React.useEffect(() => {
    const safeNiveles = Array.isArray(niveles) ? niveles : [];
    setItemsNiveles(
      safeNiveles.map((x) => ({
        id: x.id,
        descripcion: x.descripcion,
        nroNivel: x.nroNivel,
        opciones: mapToItem(x).opciones,
      }))
    );
    setCurrentPage(1);
  }, [niveles, mapToItem]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (descripcion) => {
    props.handleOnSearch(descripcion);
    setCurrentPage(1);
  };

  // Elementos en página actual
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = itemsNiveles.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <TitleBar
        title={"Niveles"}
        handleOnSearch={handleSearch}
        searchPlaceholder="Nivel"
        showSearch={true}
        newButtonLink={undefined}
        validator="nombreynumeros"
      />

      <Row style={{ margin: "0px" }} className="draggable">
        {currentItems &&
          currentItems.map((item, index) => (
            <Col md={6} lg={4} key={index} className="draggable">
              <Item item={item} {...props} />
            </Col>
          ))}
      </Row>

      {(props.niveles === undefined || props.niveles.length === 0) && (
        <div className="noNiveles">No se encontraron niveles.</div>
      )}

      {props.openModal && (
        <MyDialog
          cuerpo={props.mensaje}
          botonConfirmar={props.labelModalOk}
          handleOnConfirmar={() => {
            props.handleModalOk();
            setTimeout(props.handleOnSearch, 600);
          }}
          handleOnCancelar={props.handleCloseModal}
        />
      )}

      {/* Paginación */}
      {itemsNiveles.length > itemsPerPage && (
        <Pagination
          handleOnChange={handlePageChange}
          page={currentPage}
          totalPages={Math.ceil(itemsNiveles.length / itemsPerPage)}
        />
      )}
    </>
  );
};

NivelesListado.propTypes = {
  niveles: PropTypes.array.isRequired,
  handleOnSearch: PropTypes.func.isRequired,
  mensaje: PropTypes.string,
  labelModalOk: PropTypes.string,
  handleModalOk: PropTypes.func,
  handleCloseModal: PropTypes.func,
  openModal: PropTypes.bool,
};

NivelesListado.defaultProps = {
  niveles: [],
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetNiveles,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(NivelesListado);
